// 待ち牌計算ユーティリティ (React版)

// 牌の文字列表現
export const TILE_NAMES = {
  manzu: ['', '一萬', '二萬', '三萬', '四萬', '五萬', '六萬', '七萬', '八萬', '九萬'],
  pinzu: ['', '一筒', '二筒', '三筒', '四筒', '五筒', '六筒', '七筒', '八筒', '九筒'],
  souzu: ['', '一索', '二索', '三索', '四索', '五索', '六索', '七索', '八索', '九索'],
  jihai: ['東', '南', '西', '北', '白', '發', '中']
};

// 牌画像のパス (public フォルダ内)
export const TILE_IMAGES = {
  manzu: {
    1: '/images/pai/manzu/1.gif',
    2: '/images/pai/manzu/2.gif',
    3: '/images/pai/manzu/3.gif',
    4: '/images/pai/manzu/4.gif',
    5: '/images/pai/manzu/5.gif',
    6: '/images/pai/manzu/6.gif',
    7: '/images/pai/manzu/7.gif',
    8: '/images/pai/manzu/8.gif',
    9: '/images/pai/manzu/9.gif',
  },
  pinzu: {
    1: '/images/pai/pinzu/1.gif',
    2: '/images/pai/pinzu/2.gif',
    3: '/images/pai/pinzu/3.gif',
    4: '/images/pai/pinzu/4.gif',
    5: '/images/pai/pinzu/5.gif',
    6: '/images/pai/pinzu/6.gif',
    7: '/images/pai/pinzu/7.gif',
    8: '/images/pai/pinzu/8.gif',
    9: '/images/pai/pinzu/9.gif',
  },
  souzu: {
    1: '/images/pai/sozu/1.gif',
    2: '/images/pai/sozu/2.gif',
    3: '/images/pai/sozu/3.gif',
    4: '/images/pai/sozu/4.gif',
    5: '/images/pai/sozu/5.gif',
    6: '/images/pai/sozu/6.gif',
    7: '/images/pai/sozu/7.gif',
    8: '/images/pai/sozu/8.gif',
    9: '/images/pai/sozu/9.gif',
  },
  jihai: [
    '/images/pai/tupai/e.gif',    // 東
    '/images/pai/tupai/s.gif',    // 南
    '/images/pai/tupai/w.gif',    // 西
    '/images/pai/tupai/n.gif',    // 北
    '/images/pai/tupai/haku.gif', // 白
    '/images/pai/tupai/hatsu.gif',// 發
    '/images/pai/tupai/chu.gif',  // 中
  ]
};

// 牌画像を取得する関数
export const getTileImage = (tile) => {
  try {
    if (tile.type === 'jihai' && tile.jihai !== undefined) {
      const jihaiIndex = ['east', 'south', 'west', 'north', 'haku', 'hatsu', 'chun'].indexOf(tile.jihai);
      if (jihaiIndex >= 0 && jihaiIndex < TILE_IMAGES.jihai.length) {
        return TILE_IMAGES.jihai[jihaiIndex];
      }
    } else if (tile.number && tile.type !== 'jihai' && tile.number >= 1 && tile.number <= 9) {
      const image = TILE_IMAGES[tile.type][tile.number];
      if (image) {
        return image;
      }
    }
  } catch (error) {
    console.warn('画像取得エラー:', error, tile);
  }
  
  // フォールバック: 1萬の画像を返す
  return TILE_IMAGES.manzu[1];
};

// 空の手牌を初期化
export const createEmptyHand = () => ({
  manzu: new Array(10).fill(0), // index 0は未使用
  pinzu: new Array(10).fill(0),
  souzu: new Array(10).fill(0), 
  jihai: new Array(7).fill(0)
});

// 手牌の総枚数を取得
export const getTotalTileCount = (hand) => {
  return [
    ...hand.manzu.slice(1),
    ...hand.pinzu.slice(1), 
    ...hand.souzu.slice(1),
    ...hand.jihai
  ].reduce((sum, count) => sum + count, 0);
};

// 牌の文字列表現を取得
export const getTileName = (tile) => {
  if (tile.type === 'jihai' && tile.jihai) {
    const jihaiIndex = ['east', 'south', 'west', 'north', 'haku', 'hatsu', 'chun'].indexOf(tile.jihai);
    return TILE_NAMES.jihai[jihaiIndex];
  } else if (tile.number) {
    return TILE_NAMES[tile.type][tile.number];
  }
  return '';
};

// 待ち牌を計算する main function
export const calculateWaitingTiles = (hand) => {
  // 手牌の枚数チェック
  const totalTiles = getTotalTileCount(hand);
  
  if (totalTiles === 0) {
    return {
      waitingTiles: [],
      completedHands: [],
      isValid: false,
      errorMessage: '牌を入力してください'
    };
  }

  // 13枚または16枚チェック（面前または副露）
  if (totalTiles !== 13 && totalTiles !== 10 && totalTiles !== 7 && totalTiles !== 4 && totalTiles !== 1) {
    return {
      waitingTiles: [],
      completedHands: [],
      isValid: false,
      errorMessage: `牌の枚数が不正です（${totalTiles}枚）。13枚（テンパイ）、10枚、7枚、4枚、1枚のいずれかで入力してください`
    };
  }

  const waitingTiles = [];
  const completedHands = [];

  // 全ての牌を試して上がれるかチェック
  const allTileTypes = [
    // 萬子
    ...Array.from({length: 9}, (_, i) => ({type: 'manzu', number: i + 1})),
    // 筒子  
    ...Array.from({length: 9}, (_, i) => ({type: 'pinzu', number: i + 1})),
    // 索子
    ...Array.from({length: 9}, (_, i) => ({type: 'souzu', number: i + 1})),
    // 字牌
    {type: 'jihai', jihai: 'east'},
    {type: 'jihai', jihai: 'south'},
    {type: 'jihai', jihai: 'west'},
    {type: 'jihai', jihai: 'north'},
    {type: 'jihai', jihai: 'haku'},
    {type: 'jihai', jihai: 'hatsu'},
    {type: 'jihai', jihai: 'chun'},
  ];

  for (const testTile of allTileTypes) {
    // テスト用の手牌を作成（1枚追加）
    const testHand = JSON.parse(JSON.stringify(hand));
    
    if (testTile.type === 'jihai' && testTile.jihai) {
      const jihaiIndex = ['east', 'south', 'west', 'north', 'haku', 'hatsu', 'chun'].indexOf(testTile.jihai);
      testHand.jihai[jihaiIndex]++;
    } else if (testTile.number) {
      testHand[testTile.type][testTile.number]++;
    }

    // 既に4枚持っている牌はスキップ
    const currentCount = getCurrentTileCount(hand, testTile);
    if (currentCount >= 4) continue;

    // 和了判定
    if (isWinningHand(testHand)) {
      // その牌が実際に必要だったかを確認するため、元の手牌でも和了できるかチェック
      if (!isWinningHand(hand)) {
        const tile = {
          type: testTile.type,
          number: testTile.number,
          jihai: testTile.jihai
        };
        
        waitingTiles.push(tile);
        
        // 完成形の詳細を分析
        const mentuList = analyzeMentsu(testHand);
        completedHands.push({
          waitingTile: tile,
          mentuList,
          atama: tile, // 簡略化
          isComplete: true
        });
      }
    }
  }

  return {
    waitingTiles,
    completedHands,
    isValid: true,
    errorMessage: waitingTiles.length === 0 ? '待ち牌がありません' : undefined
  };
};

// 現在の牌の枚数を取得
const getCurrentTileCount = (hand, tile) => {
  if (tile.type === 'jihai' && tile.jihai) {
    const jihaiIndex = ['east', 'south', 'west', 'north', 'haku', 'hatsu', 'chun'].indexOf(tile.jihai);
    return hand.jihai[jihaiIndex];
  } else if (tile.number) {
    return hand[tile.type][tile.number];
  }
  return 0;
};

// 和了判定（簡略化版）
const isWinningHand = (hand) => {
  const totalTiles = getTotalTileCount(hand);
  
  // 14枚でない場合は和了ではない
  if (totalTiles !== 14) return false;

  // 七対子判定
  if (isChitoitsu(hand)) return true;

  // 国士無双判定
  if (isKokushi(hand)) return true;

  // 4面子1雀頭判定
  return isNormalWinningHand(hand);
};

// 七対子判定
const isChitoitsu = (hand) => {
  const allCounts = [
    ...hand.manzu.slice(1),
    ...hand.pinzu.slice(1),
    ...hand.souzu.slice(1),
    ...hand.jihai
  ];

  // 7つのペアがある = 7つの牌が2枚ずつ
  const pairCount = allCounts.filter(count => count === 2).length;
  const otherCount = allCounts.filter(count => count !== 0 && count !== 2).length;
  
  return pairCount === 7 && otherCount === 0;
};

// 国士無双判定  
const isKokushi = (hand) => {
  let totalKokushiCount = 0;
  let pairCount = 0;

  // 萬筒索の1,9をチェック
  for (const suit of ['manzu', 'pinzu', 'souzu']) {
    for (const num of [1, 9]) {
      const count = hand[suit][num];
      if (count === 1) {
        totalKokushiCount++;
      } else if (count === 2) {
        totalKokushiCount += 2;
        pairCount++;
      } else if (count > 2 || (count === 0)) {
        return false; // 不要な牌があるか必要な牌がない
      }
    }
  }

  // 字牌をチェック
  for (let i = 0; i < 7; i++) {
    const count = hand.jihai[i];
    if (count === 1) {
      totalKokushiCount++;
    } else if (count === 2) {
      totalKokushiCount += 2;
      pairCount++;
    } else if (count > 2 || count === 0) {
      return false;
    }
  }

  // 13種の牌が1枚ずつ + 1種が追加で1枚（計14枚）
  return totalKokushiCount === 14 && pairCount === 1;
};

// 通常の4面子1雀頭判定（再帰的アルゴリズム）
const isNormalWinningHand = (hand) => {
  // まず全ての可能な雀頭を試す
  return tryWithAllPossibleAtama(hand);
};

const tryWithAllPossibleAtama = (hand) => {
  // 数牌の雀頭を試す
  for (const suit of ['manzu', 'pinzu', 'souzu']) {
    for (let i = 1; i <= 9; i++) {
      if (hand[suit][i] >= 2) {
        const newHand = JSON.parse(JSON.stringify(hand));
        newHand[suit][i] -= 2;
        if (checkMentsuRecursive(newHand)) return true;
      }
    }
  }
  
  // 字牌の雀頭を試す
  for (let i = 0; i < 7; i++) {
    if (hand.jihai[i] >= 2) {
      const newHand = JSON.parse(JSON.stringify(hand));
      newHand.jihai[i] -= 2;
      if (checkMentsuRecursive(newHand)) return true;
    }
  }
  
  return false;
};

const checkMentsuRecursive = (hand) => {
  // 牌が残っていない場合は成功
  if (getTotalTileCount(hand) === 0) {
    return true;
  }

  // 字牌から処理（刻子しか作れないため）
  for (let i = 0; i < 7; i++) {
    if (hand.jihai[i] > 0) {
      // 字牌は刻子しか作れない
      if (hand.jihai[i] >= 3) {
        const newHand = JSON.parse(JSON.stringify(hand));
        newHand.jihai[i] -= 3;
        if (checkMentsuRecursive(newHand)) return true;
      }
      // 字牌で刻子が作れない場合はfalse
      return false;
    }
  }

  // 数牌の処理（最も小さい番号の牌から処理）
  for (const suit of ['manzu', 'pinzu', 'souzu']) {
    for (let i = 1; i <= 9; i++) {
      if (hand[suit][i] > 0) {
        // この牌で面子を作る試行
        let success = false;
        
        // 刻子を試す
        if (hand[suit][i] >= 3) {
          const newHand = JSON.parse(JSON.stringify(hand));
          newHand[suit][i] -= 3;
          if (checkMentsuRecursive(newHand)) {
            success = true;
          }
        }
        
        // 順子を試す（i+1, i+2が存在する場合）
        if (!success && i <= 7 && hand[suit][i + 1] >= 1 && hand[suit][i + 2] >= 1) {
          const newHand = JSON.parse(JSON.stringify(hand));
          newHand[suit][i]--;
          newHand[suit][i + 1]--;
          newHand[suit][i + 2]--;
          if (checkMentsuRecursive(newHand)) {
            success = true;
          }
        }
        
        // どちらの面子も作れない場合はfalse
        return success;
      }
    }
  }

  return true;
};

// 面子分析（簡略化版）
const analyzeMentsu = (hand) => {
  // 実装簡略化のため空配列を返す
  return [];
};